import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sum-data-cut',
  templateUrl: './sum-data-cut.component.html',
  styleUrls: ['./sum-data-cut.component.css']
})
export class SumDataCutComponent implements OnInit {

  @ViewChild('table') table: ElementRef;
  Pergroup: UntypedFormGroup;

  constructor(private spinner: NgxSpinnerService, private router: Router) {
    this.Pergroup = new UntypedFormGroup({
      szone: new UntypedFormControl('0'),
    });
  }

  ngOnInit(): void {
    this.LoadZone();
    this.LoadCaneby();
    this.setDataTeble(1);
  }
  year_n = '6869';
  ExportExcel() {
    let zone = this.Pergroup.get('szone').value;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'ข้อมูลอ้อยเข้าหีบ' + zone + '.xlsx');
  }
  numdex = 0;
  setDataTeble(id = 0) {
    this.numdex = id;
  }
  // โหลดข้อมูล zone
  zonecode: any[] = [];
  LoadZone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
        this.spinner.hide();
      }).catch(err => { throw (err) })
    this.spinner.hide();
  }

  //โหดลยอดรายวันประจำกลุ่ม
  canebygroup: any[] = [];
  sumlast: any[] = [];
  choosedate = '';
  LoadCaneby() {
    //if (zone == 0){ alert("! กรุณาเลือกโซนก่อนค่ะ !") }   
    this.spinner.show();
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbo].[v_canin${this.year_n}_report]&w=1=1`;
    axios.get(url)
      .then(res => {
        let data_a = (res.data);
        this.canebygroup = (data_a);
        this.sumlast = data_a.filter((el: any) => el.Partcode === 'BRD');
        this.filterbyzone = data_a;
        this.spinner.hide();
        console.log('sumlast', this.sumlast);
      }).catch(err => { throw (err) })
  }
  filterbyzone: any[] = [];
  Selectbyzone() {
    let szone = this.Pergroup.get('szone').value;
    if (szone.substring(0, 1) == 'P') {
      this.filterbyzone = this.canebygroup.filter((el: any) => el.Partcode === szone);
      // console.log('szone',szone.substring(0,1),szone)
    }
    else if (szone == 0) {
      this.filterbyzone = this.canebygroup;
    }
    else {
      this.filterbyzone = this.canebygroup.filter((el: any) => el.supzone === szone);
    }
  }
}
